// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"d499d220","419":"c9eb28c4","597":"b6eba52a","615":"0b32ac37","953":"f7a077a9","980":"2614c88e"}[chunkId] + ".chunk.js";
};